import AppointmentInvitationInPastModal from './AppointmentInvitationInPastModal';

export default AppointmentInvitationInPastModal;
